import { LocationSubset } from '@era/stores';
import { EnvironmentFeatures } from '@rocksoft/shared';

export interface DeviceLocationSubsetConfig {
  title: string;
  emptyMessage: string;
  featureToggle?: (features: EnvironmentFeatures) => boolean;
  locationSubset: LocationSubset;
}

export const DEVICE_LOCATION_SUBSET_CONFIGS: Record<string, DeviceLocationSubsetConfig> = {
  swapped: {
    title: 'Swapped (lost mode)',
    emptyMessage: 'No swapped devices.',
    featureToggle: (features) => features.devices?.swapped ?? false,
    locationSubset: LocationSubset.Swapped,
  },
  spare: {
    title: 'Spares',
    emptyMessage: 'No spare devices.',
    locationSubset: LocationSubset.Spare,
  },
  assigned: {
    title: 'Assigned',
    emptyMessage: 'No assigned devices.',
    locationSubset: LocationSubset.Assigned,
  },
  housekeeping: {
    title: 'Housekeeping',
    emptyMessage: 'No housekeeping devices.',
    featureToggle: (features) => features.housekeeping?.enabled ?? false,
    locationSubset: LocationSubset.Housekeeping,
  },
  staff: {
    title: 'Staff',
    emptyMessage: 'No staff devices.',
    featureToggle: (features) => features.staff?.enabled ?? false,
    locationSubset: LocationSubset.Staff,
  },
  frontdesk: {
    title: 'Front Desk',
    emptyMessage: 'No front desk devices.',
    featureToggle: (features) => features.frontdesk?.enabled ?? false,
    locationSubset: LocationSubset.FrontDesk,
  },
  bar: {
    title: 'Bar',
    emptyMessage: 'No bar devices.',
    featureToggle: (features) => features.bar?.enabled ?? false,
    locationSubset: LocationSubset.Bar,
  },
  kiosk: {
    title: 'Kiosk',
    emptyMessage: 'No kiosk devices.',
    featureToggle: (features) => features.kiosk?.enabled ?? false,
    locationSubset: LocationSubset.Kiosk,
  },
};
